import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { DashboardPage } from "./pages/DashboardPage";
import { MyPage } from "./pages/MyPage";
import { DonaturPage } from "./modules/Donatur/DonaturPage";
import { DonaturEdit } from "./modules/Donatur/donatur-edit/DonaturEdit";
import { OrganizationEdit } from "./modules/Organization/organization-edit/OrganizationEdit";
import { CollectorPage } from "./modules/Collector/CollectorPage"; // View Page List request data transaksi yang akan di lakukan collect
import { CollectPage } from "./modules/Collector/collect/CollectPage"; // View Page Request data ke Checker
import { CheckerPage } from "./modules/Checker/CheckerPage";
import { CollectorPage2 } from "./modules/Collector2/CollectorPage";
import { CollectPage2 } from "./modules/Collector2/collect/CollectPage";
import { CheckerPage2 } from "./modules/Checker2/CheckerPage";
// import {ReportPage} from './modules/Report/ReportPage'
import { shallowEqual, useSelector } from "react-redux";
import { PrivateRoute } from "./PrivateRoute";
import { ExportListPage } from "./modules/ExportList/ExportListPage";
import { BlockOrg, RoleChecker } from "./RoleChecker";
import { ProgramPage } from "./modules/MasterData/pages/program/ProgramPage";
import { UserPage } from "./modules/MasterData/pages/user/UserPage";
import { AccessRolePage } from "./modules/MasterData/pages/access-role/AccessRolePage";
import { ReconcilePage } from "./modules/Donation/pages/reconcile/ReconcilePage";
import { ReconcileEditPage } from "./modules/Donation/pages/reconcile/reconcile-edit/ReconcileEditPage";
import { ImportMutationBankPage } from "./modules/Donation/pages/import-mutation-bank/ImportMutationBankPage";
import { ImportMutationBankCreateDialog } from "./modules/Donation/pages/import-mutation-bank/import-mutation-bank-create-dialog/ImportMutationBankCreateDialog";
import { ImportMutationBankEditDialog } from "./modules/Donation/pages/import-mutation-bank/import-mutation-bank-edit-dialog/ImportMutationBankEditDialog";
import { BankKurbanPage } from "./modules/Donation/pages/bank-kurban/BankKurbanPage";
import { BankKurbanDialog } from "./modules/Donation/pages/bank-kurban/bank-kurban-dialog/BankKurbanDialog";
import ComingSoonPage from "../_metronic/layout/components/coming-soon/ComingSoonPage";
import { BenefisCategoryPage } from "./modules/BenefisCategory/pages/BenefisCategoryPage";
import { BenefisPage } from "./modules/Benefis/pages/BenefisPage";
import { BenefisEditDialog } from "./modules/Benefis/pages/benefis-edit-dialog/BenefisEditDialog";
import { BenefisDeleteDialog } from "./modules/Benefis/pages/benefis-delete-dialog/BenefisDeleteDialog";
import { BenefisImportIndividual } from "./modules/Benefis/pages/benefis-import-individual/BenefisIndividualImport";
import { BenefisImportOrganization } from "./modules/Benefis/pages/benefis-import-organization/BenefisOrganizationImport";
import UserProfilePage from "./modules/Profile/UserProfilePage";
import { ProjectPage } from "./modules/Project/pages/ProjectPage";
import { ProjectEditDialog } from "./modules/Project/pages/project-edit-dialog/ProjectEditDialog";
import { ImportDonaturDialog } from "./modules/Donatur/import-donatur-dialog/ImportDonaturDialog";
import ProjectManage from "./modules/Project/pages/project-manage-dialog/ProjectManage";
import { PlanUsageLogPage } from "./modules/PlanUsageLog/pages/PlanUsageLogPage";
import { BillingPage } from "./modules/Billing/pages/BillingPage";
import { TopUpPage } from "./modules/TopUp/pages/TopUpPage";
import { PlanBalancePage } from "./modules/PlanBalance/pages/PlanBalancePage";
import { DetailTopUpInvPage } from "./modules/TopUp/pages/invoice-detail/DetailTopUpInvPage";
import { KurbanPage } from "./modules/Donation/pages/kurban/kurban-list/KurbanPage";
import { HewanKurbanPage } from "./modules/Donation/pages/kurban/hewan-kurban/HewanKurbanPage";
import { HewanKurbanCampaignPage } from "./modules/Donation/pages/kurban/hewan-kurban-campaign/HewanKurbanCampaignPage";
import { PeriodeKurbanPage } from "./modules/Donation/pages/kurban/periode-kurban/PeriodeKurbanPage";
import { PartnerPage } from "./modules/Partner/pages/PartnerPage";
import { AreaPage } from "./modules/Area/pages/AreaPage";
import { PartnerQuotaPage } from "./modules/PartnerQuota/pages/PartnerQuotaPage";
import { PartnerQuotaHistoryPage } from "./modules/PartnerQuota/pages/partner-quota-history-page/PartnerQuotaHistoryPage";
import { PartnerQuotaEditDialog } from "./modules/PartnerQuota/pages/partner-quota-edit-dialog/PartnerQuotaEditDialog";
import { MergingListPage } from "./modules/MergingList/pages/MergingListPage";
import { MergingListEditDialog } from "./modules/MergingList/pages/mergingList-edit-dialog/MergingListEditDialog";
import { DistributionNormalPage } from "./modules/Distribution/Normal/pages/NormalPage";
import { DistributionMergingPage } from "./modules/Distribution/Merging/pages/MergingPage";
import { KurbanReportPage } from "./modules/Donation/pages/kurban/report/KurbanReportPage";
import KurbanReportEditDialog from "./modules/Donation/pages/kurban/report/kurban-report-edit-dialog/KurbanReportEditDialog";
import { KurbanReportDetailPage } from "./modules/Donation/pages/kurban/report/kurban-report-detail/KurbanReportDetailPage";
import { LibraryPage } from "./modules/Library/pages/LibraryPage";
import { OrganizationReportPage } from "./modules/OrganizationReport/pages/OrganizationReportPage";
import { OrganizationReportEditDialog } from "./modules/OrganizationReport/pages/organization-report-edit-dialog/OrganizationReportEditDialog";
import { ProjectCategoryPage } from "./modules/ProjectCategory/pages/ProjectCategoryPage";

const MasterDatapage = lazy(() =>
  import("./modules/MasterData/pages/MasterDataPage")
);

const DonationPage = lazy(() =>
  import("./modules/Donation/pages/DonationPage")
);
const AnalysisPage = lazy(() =>
  import("./modules/Analysis/pages/AnalysisPage")
);
const CampaignPage = lazy(() =>
  import("./modules/Campaign/pages/CampaignPage")
);

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <Route path="/billing/usage">
          <ComingSoonPage cardTitle={"Pemakaian"} />
        </Route>
        <Route path="/billing/invoice">
          <ComingSoonPage cardTitle={"Invoice"} />
        </Route>
        {/* <Route path="/kurban">
                    <ComingSoonPage
                        cardTitle={"Distribusi Kurban"}
                    />
                </Route> */}

        {/* GLOBAL */}
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />

        {/* DONASI ROLE */}
        <PrivateRoute
          role={RoleChecker("Read", "donasi")}
          component={DonationPage}
          path="/donasi"
        />
        <PrivateRoute
          role={RoleChecker("Edit", "organization")}
          component={OrganizationEdit}
          path="/organization"
          exact={true}
        />

        {/* MASTER ROLE */}
        <PrivateRoute
          role={RoleChecker("Read", "master_data")}
          component={MasterDatapage}
          path="/master-data"
        />

        {/* CHECKER ROLE
                <PrivateRoute role={checker_roles.includes(role)} component={CheckerPage} path="/checker/:id/:status"
                              exact={true}/>
                <PrivateRoute role={checker_roles.includes(role)} component={CheckerPage} path="/checker" exact={true}/> */}

        {/*CHECKER ROLE 2*/}
        <PrivateRoute
          role={RoleChecker("Read", "checker")}
          component={CheckerPage2}
          path="/checker/:id/:status"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Read", "checker")}
          component={CheckerPage2}
          path="/checker"
          exact={true}
        />

        {/* DONATUR ROLE */}
        <PrivateRoute
          role={RoleChecker("Read", "donatur")}
          component={DonaturPage}
          path="/donatur"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit Donatur", "detail_donatur")}
          component={DonaturEdit}
          path="/donatur/:id/edit"
          exact={true}
        />
        <PrivateRoute
          role={BlockOrg() && RoleChecker("Create Donatur", "daftar_donatur")}
          component={DonaturEdit}
          path="/donatur/new"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit Donatur", "detail_donatur")}
          component={DonaturEdit}
          path="/donatur/:parent_uuid/:donatur_type"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create Donatur", "daftar_donatur")}
          component={ImportDonaturDialog}
          path="/donatur/import"
          exact={true}
        />

        {/* COLLECTOR ROLE */}
        {/* <PrivateRoute role={collector_roles.includes(role)} component={CollectPage} path="/collector/collect"
                              exact/>
                <PrivateRoute role={collector_roles.includes(role)} component={CollectorPage}
                              path="/collector/:id/:status"
                              exact/>
                <PrivateRoute role={collector_roles.includes(role)} component={CollectorPage} path="/collector"
                              exact/> */}

        {/* COLLECTOR 2 ROLE */}
        <PrivateRoute
          role={RoleChecker("Read", "collector")}
          component={CollectPage2}
          path="/collector/collect"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "collector")}
          component={CollectorPage2}
          path="/collector/:id/:status"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "collector")}
          component={CollectorPage2}
          path="/collector"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "daftar_export")}
          component={ExportListPage}
          path="/export-list"
          exact={true}
        />

        {/* LAPORAN ROLE */}
        {/*<PrivateRoute role={laporan_roles.includes(role)} component={ReportPage} path="/laporan"*/}
        {/*              exact/>*/}

        <PrivateRoute
          role={RoleChecker("Read", "analisa")}
          component={AnalysisPage}
          path="/analysis"
        />

        <PrivateRoute
          role={RoleChecker("Read", "project")}
          component={ProgramPage}
          path="/program"
        />

        <PrivateRoute
          role={RoleChecker("Read", "user")}
          component={UserPage}
          path="/access/user"
        />

        <PrivateRoute
          role={RoleChecker("Read", "access_role")}
          component={AccessRolePage}
          path="/access/access-role"
        />

        {/* Settlement */}
        <PrivateRoute
          role={RoleChecker("Read", "rekonsiliasi_donasi")}
          component={ReconcilePage}
          path="/settlement/settlement"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "rekonsiliasi_donasi")}
          component={ReconcileEditPage}
          path="/settlement/settlement/new"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "rekonsiliasi_donasi")}
          component={ReconcileEditPage}
          path="/settlement/settlement/:id/edit"
          exact
        />

        {/* Bank Import */}
        {/* <PrivateRoute role={RoleChecker('Read', 'bank_import')} component={ImportMutationBankPage} path="/bank/bank/import-mutation-bank" exact/>
                <PrivateRoute role={BlockOrg() && RoleChecker('Read', 'bank_import')} component={ImportMutationBankCreateDialog} path="/bank/bank/import-mutation-bank/new" exact/>
                <PrivateRoute role={RoleChecker('Read', 'bank_import')} component={ImportMutationBankEditDialog} path="/bank/bank/import-mutation-bank/:id/edit" exact/> */}

        {/* Benefis Category */}
        <PrivateRoute
          role={RoleChecker("Read", "benefis_category")}
          component={BenefisPage}
          path="/_distribution/benefis"
          exact
        />
        <PrivateRoute
          role={BlockOrg() && RoleChecker("Read", "benefis_category")}
          component={BenefisEditDialog}
          path="/_distribution/benefis/:type/new"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "benefis_category")}
          component={BenefisEditDialog}
          path="/_distribution/benefis/:type/:id/edit"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Create", "benefis")}
          component={BenefisImportIndividual}
          path="/_distribution/benefis/import/individual"
          exact
        />

        <PrivateRoute
          role={RoleChecker("Create", "benefis")}
          component={BenefisImportOrganization}
          path="/_distribution/benefis/import/organization"
          exact
        />

        {/* User Profile */}
        <PrivateRoute
          role={true}
          component={UserProfilePage}
          path="/user-profile"
          exact
        />

        {/* Project */}
        <PrivateRoute
          role={RoleChecker("Read", "project")}
          component={ProjectPage}
          path="/_distribution/project"
          exact
        />
        <PrivateRoute
          role={BlockOrg() && RoleChecker("Read", "project")}
          component={ProjectEditDialog}
          path="/_distribution/project/new"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "project")}
          component={ProjectEditDialog}
          path="/_distribution/project/:id/edit"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "project")}
          component={ProjectManage}
          path="/_distribution/project/:id/manage"
          exact
        />

        {/* Category Project */}
        <PrivateRoute
          role={BlockOrg() && RoleChecker("Read", "project")}
          component={ProjectCategoryPage}
          path="/_distribution/category"
        />

        {/* Billing */}
        <PrivateRoute
          role={true}
          component={PlanUsageLogPage}
          path="/billing/plan-usage-log"
          exact
        />
        <PrivateRoute
          role={true}
          component={BillingPage}
          path="/billing/list"
          exact
        />
        <PrivateRoute
          role={true}
          component={TopUpPage}
          path="/billing/top-up"
          exact
        />
        <PrivateRoute
          role={true}
          component={DetailTopUpInvPage}
          path="/billing/top-up/:id/invoice"
          exact
        />
        <PrivateRoute
          role={true}
          component={PlanBalancePage}
          path="/billing/plan-balance"
          exact
        />

        {/* Kurban */}
        <PrivateRoute
          role={RoleChecker("Read", "daftar_kurban")}
          component={KurbanPage}
          path="/kurban/list"
        />

        <PrivateRoute
          role={RoleChecker("Read", "hewan_kurban")}
          component={HewanKurbanPage}
          path="/kurban/hewan-kurban"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "hewan_kurban")}
          component={HewanKurbanPage}
          path="/kurban/hewan-kurban/new"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "hewan_kurban")}
          component={HewanKurbanPage}
          path="/kurban/hewan-kurban/:id/edit"
          exact={true}
        />

        <PrivateRoute
          role={RoleChecker("Read", "hewan_kurban_campaign")}
          component={HewanKurbanCampaignPage}
          path="/kurban/campaign-hewan-kurban"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "hewan_kurban_campaign")}
          component={HewanKurbanCampaignPage}
          path="/kurban/campaign-hewan-kurban/new"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "hewan_kurban_campaign")}
          component={HewanKurbanCampaignPage}
          path="/kurban/campaign-hewan-kurban/:id/edit"
          exact={true}
        />

        <PrivateRoute
          role={RoleChecker("Read", "access_role")}
          component={PeriodeKurbanPage}
          path="/kurban/periode-kurban"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "access_role")}
          component={PeriodeKurbanPage}
          path="/kurban/periode-kurban/new"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "access_role")}
          component={PeriodeKurbanPage}
          path="/kurban/periode-kurban/:id/edit"
          exact={true}
        />

        {/* Mitra */}
        <PrivateRoute
          role={RoleChecker("Read", "mitra")}
          component={PartnerPage}
          path="/kurban/partner"
        />
        <PrivateRoute
          role={RoleChecker("Create", "mitra")}
          component={PartnerPage}
          path="/kurban/partner/new"
        />
        <PrivateRoute
          role={RoleChecker("Edit", "mitra")}
          component={PartnerPage}
          path="/kurban/partner/:id/edit"
        />

        <PrivateRoute
          role={RoleChecker("Read", "kurban-report")}
          component={KurbanReportPage}
          path="/kurban/report"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Edit", "kurban-report")}
          component={KurbanReportDetailPage}
          path="/kurban/report/:id/detail"
          exact
        />

        {/* Kuota Mitra */}
        <PrivateRoute
          role={RoleChecker("Read", "partner-quota")}
          component={PartnerQuotaPage}
          path="/kurban/quota-partner"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Read", "partner-quota")}
          component={PartnerQuotaHistoryPage}
          path="/kurban/quota-partner/history"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Create", "partner-quota")}
          component={PartnerQuotaEditDialog}
          path="/kurban/quota-partner/new"
          exact
        />
        <PrivateRoute
          role={RoleChecker("Edit", "partner-quota")}
          component={PartnerPage}
          path="/kurban/quota-partner/:id/edit"
          exact
        />

        {/* WILAYAh */}
        <PrivateRoute
          role={RoleChecker("Read", "wilayah")}
          component={AreaPage}
          path="/kurban/area"
        />
        <PrivateRoute
          role={RoleChecker("Create", "wilayah")}
          component={AreaPage}
          path="/kurban/area/new"
        />
        <PrivateRoute
          role={RoleChecker("Edit", "wilayah")}
          component={AreaPage}
          path="/kurban/area/:id/edit"
        />

        {/* SISA MERGING */}
        <PrivateRoute
          role={true}
          component={MergingListPage}
          path="/kurban/merging/list"
        />
        <PrivateRoute
          role={true}
          component={MergingListEditDialog}
          path="/kurban/merging/:id"
        />

        {/* Distribusi Normal */}
        <PrivateRoute
          role={RoleChecker("Read", "distribution")}
          component={DistributionNormalPage}
          path="/kurban/distribution/normal"
          exact
        />
        {/* Distribusi Merging */}
        <PrivateRoute
          role={RoleChecker("Read", "distribution")}
          component={DistributionMergingPage}
          path="/kurban/distribution/merging"
          exact
        />

        <PrivateRoute role={true} component={CampaignPage} path="/campaign" />

        <PrivateRoute
          role={true}
          component={LibraryPage}
          path="/elibrary"
          exact
        />
        <PrivateRoute
          role={true}
          component={LibraryPage}
          path="/elibrary/:id/detail"
        />

        <PrivateRoute
          role={true}
          component={OrganizationReportPage}
          path="/organization-report"
          exact
        />

        <PrivateRoute
          role={true}
          component={OrganizationReportEditDialog}
          path="/organization-report/new"
          exact
        />

        <PrivateRoute
          role={true}
          component={OrganizationReportEditDialog}
          path="/organization-report/:id/edit"
          exact
        />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
